@if (size$ | async; as size) {
  <div class="desktop-welcome-screen-overlay">
    @if (size === BreakpointNames.DESKTOP) {
      <cp-desktop-welcome-modal
        (skipButtonClick)="cancelTutorials()"
        [modalTemplateData]="modalTemplateData"
        [welcomeModalData]="welcomeModalData" />
    }
    @if (size === BreakpointNames.MOBILE || size === BreakpointNames.TABLET) {
      <cp-mobile-welcome-modal
        (skipButtonClick)="cancelTutorials()"
        [modalTemplateData]="modalTemplateData"
        [welcomeModalData]="welcomeModalData" />
    }
  </div>
}
